module.exports = __webpack_public_path__ + "static/media/jumbotron__image--6.0678a078.jpg";